import { z } from 'zod';

export const patientSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  dateOfBirth: z.string().min(1, 'Date of birth is required'),
});

export const insuranceSchema = z.object({
  insurer: z.string().optional(),
  memberId: z.string().optional(),
});

export const providerAssignmentSchema = z.object({
  providerId: z.string().min(1, 'Provider is required'),
  providerName: z.string(),
  role: z.string(),
});

export type PatientFormData = z.infer<typeof patientSchema>;
export type InsuranceFormData = z.infer<typeof insuranceSchema>;
export type ProviderAssignmentFormData = z.infer<typeof providerAssignmentSchema>;
